import ReactDOM from "react-dom";
import { useState } from "react"
import Button from "../../../common/Button"
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import CreateLawFirmForm from "../forms/CreateLawFirmForm";
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions";


const CreateLawFirm = ({permission}) => {
    let userPermissionDisabled = useUserTabEditPermissionDisabled(permission)

    const [modalOpned, setModalOpened] = useState(false)

    const openModalHandler = () => {
        setModalOpened(true)
    }

    const closeModalHandler = () => {
        setModalOpened(false)
    }

    return <>
        {userPermissionDisabled && <Button btnStyle={'btn_light_grey'} click={openModalHandler}><i className="ti ti-square-plus"></i>Create</Button>}
        {modalOpned && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Create New Law Firm'}>
                        <CreateLawFirmForm closeModal={closeModalHandler}/>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}

export default CreateLawFirm